import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default function Slide({ children, onClick, className }) {
  return (
    <li
      className={cn(
        'flex rounded-8 md:rounded-16  row-start-1 row-span-1 col-start-2 col-span-1 overflow-hidden shadow-blackish-offset relative',
        className
      )}
      onClick={onClick}
    >
      {children}
    </li>
  )
}

Slide.propTypes = {
  src: PropTypes.string,
  srcSet: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
}
